module.exports = __webpack_public_path__ + "img/vxinkuai.prt.220682f6.jpg";